import { BrandMark } from '../components/BrandMark';

/**
 * Aviso de privacidad público de la app Dentu (paciente). Sin auth a propósito:
 * es la URL que se declara en App Store Connect / Play Console y que cualquier
 * paciente puede consultar sin iniciar sesión.
 */
const SECCIONES = [
  {
    titulo: 'Responsable',
    texto: 'Clínica Dentu, con domicilio en Tuxtla Gutiérrez, Chiapas, México, es responsable del '
      + 'tratamiento de tus datos personales conforme a la Ley Federal de Protección de Datos '
      + 'Personales en Posesión de los Particulares (LFPDPPP).',
  },
  {
    titulo: 'Datos que recabamos',
    texto: 'Datos de identificación (nombre, apellido, teléfono); datos de salud sensibles (peso, '
      + 'medidas corporales, síntomas, objetivo y padecimientos que nos compartas); y datos de '
      + 'alimentación (qué comiste, fotos de tus comidas, vasos de agua y minutos de ejercicio).',
  },
  {
    titulo: 'Para qué los usamos',
    texto: 'Finalidades primarias (necesarias para el servicio): que tu nutrióloga dé seguimiento '
      + 'a tu plan, muestre tu progreso y te recuerde citas y registros pendientes. Finalidades '
      + 'secundarias (puedes oponerte sin que afecte tu atención): generar sugerencias automatizadas '
      + 'como listas de compra o ideas de preparación a partir de tu plan.',
  },
  {
    titulo: 'Con quién se comparten tus datos',
    texto: 'No vendemos tus datos ni los compartimos con terceros para fines de mercadotecnia. '
      + 'Cuando usas la lista de compra o pides la preparación de un platillo, únicamente el nombre '
      + 'del platillo (por ejemplo "pescado a la veracruzana") se envía a un proveedor externo de '
      + 'inteligencia artificial para generar esa respuesta. Nunca se envía tu nombre, tu teléfono, '
      + 'tus fotos ni tus datos de salud en esa solicitud.',
    destacado: true,
  },
  {
    titulo: 'Canales de registro',
    texto: 'Puedes registrar tu seguimiento desde la app Dentu o por WhatsApp con tu clínica. Ambos '
      + 'canales guardan la información en el mismo expediente clínico.',
  },
  {
    titulo: 'Tus derechos (ARCO) y cómo ejercerlos',
    texto: 'Tienes derecho a Acceder a tus datos, Rectificarlos, Cancelar su uso, u Oponerte a una '
      + 'finalidad específica, así como revocar tu consentimiento en cualquier momento. Para '
      + 'ejercerlos, contacta a tu clínica por el mismo WhatsApp donde te atienden, indicando tu '
      + 'nombre y teléfono registrado.',
  },
  {
    titulo: 'Borrar tu cuenta de la app',
    texto: 'Desde Perfil → Privacidad puedes borrar en cualquier momento lo que registraste desde '
      + 'la app. Tu expediente clínico y lo registrado por WhatsApp se conservan, porque forman '
      + 'parte de tu historial médico con la clínica.',
  },
  {
    titulo: 'Cambios a este aviso',
    texto: 'Si actualizamos este aviso de forma relevante, te lo notificaremos dentro de la app '
      + 'antes de que entre en vigor.',
  },
];

export const PrivacyPage = () => (
  <div className="min-h-screen bg-background text-foreground">
    <div className="mx-auto max-w-2xl px-6 py-16">
      <div className="flex items-center gap-3 mb-2">
        <BrandMark className="h-8 w-8" />
        <span className="text-sm font-medium tracking-wide text-muted-foreground uppercase">
          Dentu · Clínica de nutrición
        </span>
      </div>
      <h1 className="text-3xl font-semibold tracking-tight mb-1">Aviso de privacidad</h1>
      <p className="text-sm text-muted-foreground mb-10">
        Última actualización: 14 de septiembre de 2026 · Aplica a la app móvil Dentu y al seguimiento
        por WhatsApp.
      </p>

      <div className="space-y-8">
        {SECCIONES.map((seccion) => (
          <section
            key={seccion.titulo}
            className={seccion.destacado ? 'rounded-xl border bg-muted/40 p-5' : ''}
          >
            <h2 className="text-lg font-semibold mb-2">{seccion.titulo}</h2>
            <p className="text-sm leading-relaxed text-muted-foreground">{seccion.texto}</p>
          </section>
        ))}
      </div>

      <p className="mt-12 pt-6 border-t text-xs text-muted-foreground">
        Este aviso describe, en términos sencillos, lo que la app Dentu realmente hace con tus datos.
        No sustituye asesoría legal formal; la clínica puede complementarlo según sus propias
        políticas internas.
      </p>
    </div>
  </div>
);
